module.exports = __webpack_public_path__ + "static/media/icon-problematic-device.61bef035.svg";